import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const DecreaseIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM17.5 12C17.5 11.7239 17.2761 11.5 17 11.5H7L6.91012 11.5081C6.67688 11.5504 6.5 11.7545 6.5 12C6.5 12.2761 6.72386 12.5 7 12.5H17L17.0899 12.4919C17.3231 12.4496 17.5 12.2455 17.5 12Z'
        fill='currentColor'
      />
    </svg>
  );
};
